(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["galmino-sticky-atc"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('galmino-sticky')) {
    customElements.define('galmino-sticky', class extends HTMLElement {
      connectedCallback() {
        this.form = document.getElementById(this.dataset.form);
        if (!this.form) return;
        this.nativeButton = this.form.querySelector('[type="submit"]');
        this.button = this.querySelector('button');
        this.label = this.querySelector('.galmino-sticky__variant');
        this.variants = JSON.parse(this.querySelector('script').textContent);
        this.sync = () => {
          const variant = this.variants.find(v => String(v.id) === this.form.querySelector('[name="id"]')?.value);
          const disabled = !variant?.available || this.nativeButton?.disabled || this.nativeButton?.getAttribute('aria-disabled') === 'true';
          if (this.button.disabled !== Boolean(disabled)) this.button.disabled = Boolean(disabled);
          if (variant) {
            const text = variant.title + ' · ' + new Intl.NumberFormat('en-US', { style: 'currency', currency: this.dataset.currency }).format(variant.price / 100) + ' ' + this.dataset.currency;
            if (this.label.textContent !== text) this.label.textContent = text;
          }
        };
        this.submit = () => { this.sync(); if (!this.button.disabled) this.nativeButton?.click(); };
        this.button.addEventListener('click', this.submit);
        this.form.querySelector('[name="id"]')?.addEventListener('change', this.sync);
        this.observer = new MutationObserver(this.sync);
        const root = this.form.closest('product-info') || this.form.closest('.product__info-container');
        if (root) this.observer.observe(root, { subtree: true, childList: true, attributes: true, attributeFilter: ['disabled', 'aria-disabled', 'value'] });
        this.visibility = () => this.classList.toggle('is-visible', this.nativeButton.getBoundingClientRect().bottom < 0);
        this.intersection = new IntersectionObserver(this.visibility);
        this.intersection.observe(this.nativeButton);
        window.addEventListener('scroll', this.visibility, { passive: true });
        this.sync(); this.visibility();
      }
      disconnectedCallback() {
        this.observer?.disconnect(); this.intersection?.disconnect();
        window.removeEventListener('scroll', this.visibility);
        this.button?.removeEventListener('click', this.submit);
        this.form?.querySelector('[name="id"]')?.removeEventListener('change', this.sync);
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
